import javaService from "../../utils/request"

 // banner
 export function indexRotationChart(data){
  return javaService({
    url: '/front/rotationChart',
    method: 'get',
    params: data,
  })
 }
// banner跳转验证
export function indexIsExist(data){
  return javaService({
    url: '/hkArticle/isExist',
    method: 'get',
    params: data,
  })
}
// 分类名称
// export function indexClassificationList(data){
//   return javaService({
//     url: '/front/classificationList',
//     method: 'get',
//     params: data,
//   })
// }
export function indexClassificationList(data){
  return javaService({
    url: '/front/classificationByIdentification',
    method: 'get',
    params: data,
  })
}
// 最新文章
export function indexLatestArticles(data){
  return javaService({
    url: '/front/latestArticles',
    method: 'get',
    params: data,
  })
}